import GraduateOrDischarge from './GraduateOrDischarge';

export default GraduateOrDischarge;
